import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import PropTypes from 'prop-types'

export default function AlertDialog ({ isOpen, handleClose, dialogTitle, dialogContent, handleAgree }) {
  const disagree = () => {
    handleClose()
  }
  const agree = () => {
    handleAgree()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={disagree}>Cancel</Button>
          <Button onClick={agree} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

AlertDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  handleAgree: PropTypes.func,
  dialogTitle: PropTypes.string,
  dialogContent: PropTypes.string
}
